import headBanner from "../../../assets/images/backgrounds/head-banner.png";
import LinkPage from "../../LinkPage";
import { Container } from "reactstrap";

export default function HeaderBanner(props) {
  const {
    backgroundImage = headBanner,
    mobileBackgroundImage,
    linkPage = [],
    destinationName = "",
    destinationDescription = "",
    destinationHoverDescription = "",
  } = props;

  const renderBanner = (bgImage, extraClass = "") => {
    if (!bgImage.includes("null")) {
      return (
        <section
          className={`head-banner ${extraClass}`}
          style={{
            backgroundImage: `linear-gradient( rgba(8, 8, 37, 0.87), rgba(0, 0, 0, 0.44)), url("${bgImage}")`,
          }}
        >
          <Container className="h-100 d-flex  align-items-center">
            <div />
            <div>
              <h2>{destinationName}</h2>
              <p className="main-dec mobile-only">{destinationDescription}</p>
              <p className="main-dec  desktop-only">
                {destinationHoverDescription}
              </p>
            </div>
          </Container>
        </section>
      );
    } else {
      return (
        <section
          className={`head-banner ${extraClass}`}
          style={{
            backgroundImage: `gradient( rgba(8, 8, 37, 0.30), rgba(0, 0, 0, 0.30)),url(${headBanner})`,
          }}
        >
          <Container>
            <div />
            <div>
              <h1>{destinationName}</h1>
              <p className="main-dec mobile-only">{destinationDescription}</p>
              <p className="main-dec  desktop-only">
                {destinationHoverDescription}
              </p>
            </div>
          </Container>
        </section>
      );
    }
  };

  return (
    <div>
      {mobileBackgroundImage ? (
        <>
          {renderBanner(backgroundImage, "desktop-only")}
          {renderBanner(mobileBackgroundImage, "mobile-only")}
        </>
      ) : (
        renderBanner(backgroundImage)
      )}
    </div>
  );
}
